/** OAuth banner/connect routes — failures are application errors, not deploy blips. */
export function isHubOAuthBannerApiPath(pathOrUrl: string): boolean {
  const path = pathOrUrl.split("?")[0]?.split("#")[0] ?? pathOrUrl;
  return (
    path.includes("/manufacturing/reporting/quickbooks-time/oauth/") ||
    path.includes("/accounting/quickbooks/oauth/") ||
    path.includes("/user-admin/workspace-avatar-sync/") ||
    path.includes("/user-admin/workspace-oauth/")
  );
}
